
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["column-demo-common","column-demo-markdown","column-demo-group","column-demo-stack"],
  getter: () => import(/* webpackChunkName: "meta__Column__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.en.md?type=demo')
};